import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { ModalService } from "@app/services/modal.service"
import { LangService } from "@app/services/lang.service"
import { StoreService } from "@app/services/store.service"
import { COMMON_IMPORTS } from "@app/common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ErrorComponent } from "@app/error/error.component"

@Component({
	selector: "app-footer",
	imports: [COMMON_IMPORTS, LangValPipe, ModalWrapComponent, ErrorComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<footer class="text-center d-none d-lg-block main-footer">
			<hr />
			<div>
				<span
					(click)="isErrorOpen = true"
					class="pointer"
					>{{ "contact_us" | langVal }}
				</span>
				&nbsp;&nbsp;|&nbsp;&nbsp; &nbsp;
				<span
					><a
						href="http://my-cliniq.com/"
						tabindex="-1"
						target="_blank"
						>2016-2026 © My-Cliniq.com</a
					>
				</span>
				&nbsp;&nbsp;|&nbsp;&nbsp;
				<span> {{ "version" | langVal }} {{ store.VERSION }}</span>
			</div>
		</footer>
		@if (isErrorOpen) {
			<app-modal-wrap
				(onClose)="isErrorOpen = false"
				modalWrapperClass="modal-650"
				title="how_can_we_help"
			>
				<app-error (onClose)="isErrorOpen = false" />
			</app-modal-wrap>
		}
	`,
})
export class FooterComponent {
	isErrorOpen: boolean = false
	//outputs the footer for the site

	constructor(public store: StoreService) {}
}
